var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isLoggedIn)?_c('AppBar'):_vm._e(),_c('v-main',[_c('router-view')],1),_c('v-snackbar',{attrs:{"color":_vm.snackbar.color,"multi-line":true},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){return _vm.toggleSnackbar({
            open: false,
            color: null,
            text: null,
          })}}},'v-btn',attrs,false),[_vm._v(" Κλείσιμο ")])]}}]),model:{value:(_vm.snackbar.open),callback:function ($$v) {_vm.$set(_vm.snackbar, "open", $$v)},expression:"snackbar.open"}},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")]),(_vm.isLoggedIn)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }